import { Step } from '../../components/Step';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { SelectCheckbox } from '../../components/SelectCheckbox';
import SellIcon from '@mui/icons-material/Sell';
import { fieldNameStep2 } from '../consts';
import { useTranslation } from 'react-i18next';
import { type SelectData } from '../../components/types';

type Step2Props = {
  resultGetSalaryType: SelectData[];
  showSalary: boolean;
  toggleShowSalary: (event: React.SyntheticEvent<Element, Event>, checked: boolean) => void;
};

export const Step2 = ({ resultGetSalaryType, showSalary, toggleShowSalary }: Step2Props) => {
  const { t } = useTranslation('settings');

  const hasSalaryTypes = resultGetSalaryType?.length > 0;

  return (
    <Step
      title={`${t('integrations.step')} 2`}
      subtitle={t('integrations.as a default salary concept')}
      Icon={SellIcon}
    >
      <>
        <Box mt={-2} mb={4}>
          <FormControlLabel
            label={
              hasSalaryTypes ? t('integrations.include more salary concepts') : t('integrations.you dont have salary')
            }
            control={<Checkbox />}
            onChange={toggleShowSalary}
            checked={showSalary}
            disabled={!hasSalaryTypes}
          />
        </Box>
        {showSalary && <SelectCheckbox data={resultGetSalaryType} name={fieldNameStep2} />}
      </>
    </Step>
  );
};
